module.exports = __webpack_public_path__ + "img/beginners_tips_banner.544161a4.jpg";